export const errorAction = (type, error, correlationId, requestAction) => ({
  type,
  error,
  correlationId,
  requestAction,
  id: requestAction.id
});
